<script lang="ts">
  interface Props {
    placeholder?: string;
    value?: string;
  }

  let { placeholder = "Search for a tool...", value = $bindable('') }: Props = $props();
</script>

<div class="w-full md:w-auto md:min-w-[320px]">
  <label class="flex flex-col h-12 w-full shadow-sm">
    <div class="flex w-full flex-1 items-stretch rounded-lg h-full border border-[#dce0e5] bg-white overflow-hidden transition-all">
      <div class="text-[#617589] flex items-center justify-center pl-3">
        <span class="material-symbols-outlined">search</span>
      </div>
      <input
        bind:value
        class="flex w-full min-w-0 flex-1 resize-none overflow-hidden text-[#111418] focus:outline-none focus:ring-0 border-none bg-transparent h-full placeholder:text-[#9aa2ac] px-3 text-base font-normal leading-normal"
        {placeholder}
      />
    </div>
  </label>
</div>
